export const CURRICULUM_AIMS = ['ib', 'regular', 'ims', 'wms', 'fms'] as const

export type CurriculumAim = (typeof CURRICULUM_AIMS)[number]
